import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { cn } from '../../lib/utils';

const RangeSlider = React.forwardRef(
  ({ value, onValueChange, min = 0, max = 100, step = 1, className, name }, ref) => {
    return (
      <SliderPrimitive.Root
        ref={ref}
        className={cn('relative flex w-full touch-none select-none items-center h-5', className)}
        value={value}
        onValueChange={onValueChange}
        min={min}
        max={max}
        step={step}
      >
        <SliderPrimitive.Track className="relative h-1 w-full bg-border rounded-full overflow-hidden">
          <SliderPrimitive.Range className="absolute h-full bg-border-strong" />
        </SliderPrimitive.Track>

        {value.map((_, index) => (
          <SliderPrimitive.Thumb
            key={index}
            className="flex items-center justify-center h-8 w-8 rounded-full bg-primary text-white text-[10px] font-semibold shadow-md"
            aria-label={
              name
                ? `${name} ${index === 0 ? 'minimum' : 'maximum'}`
                : `${index === 0 ? 'Minimum' : 'Maximum'} value`
            } // Accessibility: provide an explicit label for each thumb so screen readers can identify the control.
          >
            {name === 'SALARY' ? `$${value[index]}k` : `${value[index]}Y`}
          </SliderPrimitive.Thumb>
        ))}
      </SliderPrimitive.Root>
    );
  }
);

export default RangeSlider;
